import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { ChevronRight } from "../icons";
import { LinkCardProps } from "./LinkCard.types";

/** A card that goes somewhere, with an icon, a title and what is there. */
export function LinkCard({ item }: LinkCardProps) {
  const content = (
    <div className="card-body d-flex align-items-center gap-4 p-4">
      <span
        aria-hidden="true"
        className="bg-light rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 icon-circle-lg"
      >
        <FontAwesomeIcon className="fs-3 text-secondary" icon={item.icon} />
      </span>
      <span className="flex-grow-1 text-start">
        <span className="d-block h5 mb-2">{item.title}</span>
        <span className="d-block text-muted">{item.description}</span>
      </span>
      <FontAwesomeIcon aria-hidden="true" className="fs-5 text-secondary flex-shrink-0" icon={ChevronRight} />
    </div>
  );

  if (item.onClick) {
    return (
      <button aria-label={`Open ${item.title}`} className="card w-100 p-0" onClick={item.onClick} type="button">
        {content}
      </button>
    );
  }

  return (
    <Link aria-label={`Open ${item.title}`} className="card w-100 p-0" to={item.href ?? ""}>
      {content}
    </Link>
  );
}

export default LinkCard;
